<script>
import Layout from '@layouts/main';
import CountryForm from '@views/countries/form';

export default {
  name: 'CountryCreate',
  components: {
    Layout,
    CountryForm,
  },
  page() {
    return {
      title: this.$t('titles.create_country'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.countries'),
          to: { name: 'countries.index' },
        },
        {
          text: this.$t('titles.create_country'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'countries.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_country')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <CountryForm @submitted="create" />
    </b-card>
  </Layout>
</template>
